var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAlt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.25C7.65625 9.25 5.78125 7.40625 5.78125 5.15625C5.78125 2.90625 7.65625 1.0625 10 1.0625C12.3438 1.0625 14.2188 2.90625 14.2188 5.15625C14.2188 7.40625 12.3438 9.25 10 9.25ZM10 2.46875C8.4375 2.46875 7.1875 3.6875 7.1875 5.15625C7.1875 6.625 8.4375 7.84375 10 7.84375C11.5625 7.84375 12.8125 6.625 12.8125 5.15625C12.8125 3.6875 11.5625 2.46875 10 2.46875Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 19.9688H3.84375C3.21875 19.9688 2.71875 19.4688 2.71875 18.8438V16.0313C2.71875 12.9688 5.21875 10.4688 8.28125 10.4688H11.75C14.8125 10.4688 17.3125 12.9688 17.3125 16.0313V18.8438C17.2812 19.4375 16.7812 19.9688 16.1562 19.9688ZM4.125 18.5625H15.9062V16.0313C15.9062 13.75 14.0312 11.875 11.75 11.875H8.25C5.96875 11.875 4.09375 13.75 4.09375 16.0313V18.5625H4.125Z",
    fill: "#6B7280"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-alt.57fe956c594d9fa8a6523de1bdd35bc3.svg";